export enum ConflictErrorType {
  None = '',
  Driver = 'DRIVER',
  User = 'USER'
}
